import React, { useState } from 'react';

import CardDialog from '~/components/CardDialog';
import { Heading } from '~/components/core';
import SkeletonTable from '~/components/core/Skeletons/SkeletonTable';
import AddDocumentTypeButton from '~/components/SystemConfiguration/DocumentTypes/AddDocumentTypeButton';
import type { DocumentTypesFilterValues } from '~/components/SystemConfiguration/DocumentTypes/DocumentTypesFilter';
import DocumentTypesFilter, {
  DOCUMENT_TYPES_FILTER_INITIAL_VALUES,
} from '~/components/SystemConfiguration/DocumentTypes/DocumentTypesFilter';
import DocumentTypesTable from '~/components/SystemConfiguration/DocumentTypes/DocumentTypesTable';
import OperationsBreadcrumbs from '~/components/SystemConfiguration/OperationsBreadcrumbs';
import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';
import type { DocumentType } from '~/components/types/document-type';
import useDataFetcher from '~/components/useDataFetcher';

const DocumentTypesConfigurationScreen: React.FC = () => {
  const [filters, setFilters] = useState<DocumentTypesFilterValues>(DOCUMENT_TYPES_FILTER_INITIAL_VALUES);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { organization } = useSysconfig();

  const {
    isLoading,
    isError,
    data: documentTypesDict = {},
    reloadData: reloadDocumentTypes,
  } = useDataFetcher<Record<string, DocumentType>>(`/api/v1/document_types/organizations/${organization.id}`);

  const displayLoading = isLoading || isError;

  return (
    <CardDialog noCardTitle>
      <div className="flex h-full flex-col">
        <OperationsBreadcrumbs currentTab="Document Types" />
        <div className="grid grid-cols-2 items-center">
          <Heading className="mt-20">Document Types</Heading>
          <AddDocumentTypeButton documentTypesDict={documentTypesDict} reloadDocumentTypes={reloadDocumentTypes} />
        </div>
        <div className="mt-20">
          <DocumentTypesFilter onChange={setFilters} />
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto">
          {displayLoading ? (
            <SkeletonTable rowsCount={10} columnsCount={10} isError={isError} />
          ) : (
            <DocumentTypesTable
              documentTypesDict={documentTypesDict}
              reloadDocumentTypes={reloadDocumentTypes}
              searchTerm={filters.search}
              selectedLobs={filters.lobs}
              showOnlyCustomTypes={filters.showOnlyCustomTypes}
              showOnlyEnabled={filters.showOnlyEnabled}
            />
          )}
        </div>
      </div>
    </CardDialog>
  );
};

export default DocumentTypesConfigurationScreen;
